export const UserManagementOnboarding = [
  {
    title: "Invita usuarios para que te ayuden en la gestión",
    description:
      "Envía una invitación vía correo electrónico y asignales un rol a los personas que te apoyarán con la gestión de los ingresos y egresos de tu empresa.",
    image: "https://cdn01.prd.symfonia.io/Gifs/invitarusuarios.gif",
    alt: "Invitar usuarios",
  },
];
